import { EMPTY_VALUE, PARAM_TYPE_STRING } from "constant/application";
import { PropFormikField } from "constant/prop-types";
import PropTypes from "prop-types";
import React from "react";
import { FormControl } from "react-bootstrap";

function StringField(props) {
  const { field, handleChange, isRequired, readOnly } = props;

  return (
    <FormControl
      type="text"
      disabled={readOnly}
      name={field.name}
      onChange={(e) => handleChange(e.target.value)}
      required={isRequired}
      value={field.value ? field.value : EMPTY_VALUE[PARAM_TYPE_STRING]}
    />
  );
}

StringField.propTypes = {
  field: PropFormikField.isRequired,
  handleChange: PropTypes.func.isRequired,
  isRequired: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
};

export { StringField };
